import _ from 'lodash';

import { useFeatures } from './features';
import featuresConfig from './featuresConfig';
import priceRanges from './priceRanges';
import { raw_strings as strings, stringsFor } from '../../location/locales';

const findFeatureByKey = (features, callback) => key => callback(features.find(f => key === f.key));
const featureFiltersOption = features => findFeatureByKey(features, f => f.analyticsOption);
const featureFiltersName = features => findFeatureByKey(features, f => f.name);
const currentLocale = document.querySelector('html').getAttribute('lang');
const colorTranslations = stringsFor(currentLocale).shingles.colors;

const filtersConfig = features => ({
  colors: {
    analytics: {
      name: strings.shingles.filters.colors,
      option: color => _.startCase(`${color}s`),
    },
    label: color => colorTranslations[color],
    tabIndex: 0,
  },
  names: {
    analytics: {
      name: strings.shingles.filters.lines,
      option: name => name,
    },
    label: name => name,
    tabIndex: 0,
  },
  prices: {
    analytics: {
      name: strings.shingles.filters.prices,
      option: uid => priceRanges.find(p => p.uid === uid).analyticsName,
    },
    label: uid => priceRanges.find(p => p.uid === uid).name,
    tabIndex: 0,
  },
  features: {
    analytics: {
      name: featuresConfig.features.analytics.name,
      option: featureFiltersOption(features),
    },
    label: featureFiltersName(features),
    tabIndex: 0,
  },
  windResistances: {
    analytics: {
      name: featuresConfig.windResistances.analytics.name,
      option: featureFiltersOption(features),
    },
    label: findFeatureByKey(features, f => f.value),
    tabIndex: 0,
  },
  impactResistances: {
    analytics: {
      name: featuresConfig.impactResistances.analytics.name,
      option: featureFiltersOption(features),
    },
    label: findFeatureByKey(features, f => f.name),
    tabIndex: 0,
  },
  warranties: {
    analytics: {
      name: featuresConfig.warranties.analytics.name,
      option: featureFiltersOption(features),
    },
    label: featureFiltersName(features),
    tabIndex: 0,
  },
});

export const useFiltersConfig = () => {
  const features = useFeatures();
  if (!features) {
    return null;
  }
  return filtersConfig(features);
};
